module.exports = __webpack_public_path__ + "static/thinking-of-buying-square-540w-af1570de0670d2345452e03d610804da.jpg";